module.exports = __webpack_public_path__ + "img/plan-2-b3.3e7349e1.png";